import { render } from "./Update.vue?vue&type=template&id=55d462e4&lang=pug"
import script from "./Update.vue?vue&type=script&lang=js"
export * from "./Update.vue?vue&type=script&lang=js"
script.render = render

export default script